import React, { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Switch, Space } from "antd";
import { AutoComplete } from "primereact/autocomplete";
import apiClient from "../../service/Axios";
import { Dialog } from "primereact/dialog";
import { toast } from "react-hot-toast";

const TeamMemberEditModal = ({ visible, setVisible, memberData }) => {
  const [techData, settechData] = useState(null);
  const [selectedTechListData, setSelectedTechListData] = useState(techData);
  const [techListData, setTechListData] = useState([]);
  const [techService, setTechService] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [filteredTechListData, setFilteredTechListData] = useState(null);
  const [teamListData, setTeamListData] = useState([]);
  const [selectedTeamListData, setSelectedTeamListData] = useState(null);
  const [filteredTeamListData, setFilteredTeamListData] = useState(null);
  console.log("techData", techData);
  const [value, setValue] = useState({
    name: "",
    email: "",
    tc: true,
    techlist: [],
    teams: [],
    password: "",
    password2: "",
    active: true,
  });

  console.log("memberdata", memberData);
  useEffect(() => {
    if (memberData) {
      setValue({
        name: memberData?.name,
        email: memberData?.email,
        tc: memberData?.tc,
        techlist: memberData.techs?.map((tech) => tech.name),
        password: "",
        password2: "",
        active: memberData.active || true,
      });
    }
  }, [memberData]);

  //techlist get api called
  useEffect(() => {
    apiClient
      .get(`${process.env.REACT_APP_AUTHENTICATION_API}/user/tech/list`)
      .then((res) => {
        setTechService(res?.data);
        setTechListData(res?.data);

        // Set selected tech list data based on memberData
        if (memberData) {
          const selectedTechs =
            memberData.techs?.map((tech) => tech.name) || [];
          setSelectedTechListData(selectedTechs);
          setValue((prev) => ({
            ...prev,
            techlist: selectedTechs,
          }));
        }
      })
      .catch((error) => {
        console.error("Error fetching tech list data:", error);
      });
  }, [memberData]);

  // Team list get API called
  useEffect(() => {
    apiClient
      .get(`${process.env.REACT_APP_API}/user/teams/list`)
      .then((res) => {
        setTeamListData(res?.data);

        // Set selected team list data based on memberData
        if (memberData) {
          const selectedTeams =
            memberData.teams?.map((team) => team.team) || [];
          setSelectedTeamListData(selectedTeams);
          setValue((prev) => ({
            ...prev,
            teams: selectedTeams,
          }));
        }
      })
      .catch((error) => {
        console.error("Error fetching team list data:", error);
      });
  }, [memberData]);

  const searchTeams = (event) => {
    setTimeout(() => {
      const _filteredTeamListData = event.query.trim()
        ? teamListData
            .filter((team) =>
              team.team.toLowerCase().startsWith(event.query.toLowerCase())
            )
            .map((team) => ({ name: team.team, id: team.id })) // Extract the "team" property
        : [];

      setFilteredTeamListData(_filteredTeamListData);
    }, 250);
  };

  //for techlist suggestion autocomplete
  const search = (event) => {
    setTimeout(() => {
      const _filteredTechListData = event.query.trim()
        ? techListData.filter((country) =>
            country.name.toLowerCase().startsWith(event.query.toLowerCase())
          )
        : [];

      setFilteredTechListData(_filteredTechListData);
    }, 250);
  };

  useEffect(() => {
    setTechListData(techService);
  }, [techService]);

  //active inactive switch
  const handleSwitchToggle = (checked) => {
    setValue((prev) => ({
      ...prev,
      active: checked,
    }));
  };

  //team member registration function

  const handleTeamRegister = (e) => {
    e.preventDefault();
    console.log("value", value);
    const formattedTeams = selectedTeamListData.map((team) => ({
      name: team.name,
      id: team.id,
    }));

    const formattedTechlist = selectedTechListData.map((tech) => ({
      id: tech.id,
      name: tech.name,
    }));

    apiClient
      .patch(
        `${process.env.REACT_APP_AUTHENTICATION_API}/user/update/${memberData?.id}`,
        {
          name: value.name,
          email: value.email,
          tc: value.tc,
          techlist: formattedTechlist,
          teams: formattedTeams,
          password: value.password,
          password2: value.password2,
          active: value.active,
        }
      )
      .then((res) => {
        toast.success("Team member registration done successfully");
        setValue({
          name: "",
          email: "",
          tc: true,
          techlist: null,
          password: "",
          password2: "",
          active: true,
        });
        // setVisible(false);
      })
      .catch((error) => {
        console.error("Error updating team member:", error);
      });
  };

  return (
    <div className="card flex justify-content-center">
      <Dialog
        header="Edit team member"
        visible={visible}
        style={{
          width: "50vw",
          background: "#fff",
          color: "black",
          padding: "20px 30px",
          marginBottom: "20px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        }}
        onHide={() => setVisible(false)}>
        <form
          onSubmit={handleTeamRegister}
          className="grid grid-cols-1 gap-3 mt-10 mx-10">
          <div className="form-control">
            <label
              htmlFor="name"
              className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
              Full Name
            </label>
            <input
              type="name"
              id="name"
              name="name"
              className="input input-bordered w-full rounded-[5px] h-10"
              value={value.name}
              onChange={(e) => {
                setValue((prev) => ({
                  ...prev,
                  name: e.target.value,
                }));
              }}
            />
          </div>

          <div className="form-control">
            {" "}
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="input input-bordered w-full rounded-[5px] h-10"
              value={value.email}
              onChange={(e) => {
                setValue((prev) => ({
                  ...prev,
                  email: e.target.value,
                }));
              }}
            />
          </div>
          <div className="form-control">
            <div className="flex justify-between items-center">
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
                Password
              </label>{" "}
            </div>
            <div className="relative">
              <input
                type={`${showPassword ? "text" : "password"}`}
                id="password"
                name="password"
                value={value.password}
                onChange={(e) => {
                  setValue((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }));
                }}
                className="input input-bordered w-full rounded-[5px] h-10"
              />

              {showPassword ? (
                <AiOutlineEye
                  className="absolute top-3 right-3 text-xl text-gray-600 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                />
              ) : (
                <AiOutlineEyeInvisible
                  className="absolute top-3 text-xl right-3 text-gray-400 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                />
              )}
            </div>
          </div>
          <div className="form-control">
            <div className="flex justify-between items-center">
              <label className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
                Confirm Password
              </label>
            </div>
            <div className="relative">
              <input
                type={`${showConfirmPassword ? "text" : "password"}`}
                id="password2"
                name="password2"
                value={value.password2}
                onChange={(e) => {
                  setValue((prev) => ({
                    ...prev,
                    password2: e.target.value,
                  }));
                }}
                className="input input-bordered w-full rounded-[5px] h-10"
              />

              {showConfirmPassword ? (
                <AiOutlineEye
                  className="absolute top-3 right-3 text-xl text-gray-600 cursor-pointer"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                />
              ) : (
                <AiOutlineEyeInvisible
                  className="absolute top-3 text-xl right-3 text-gray-400 cursor-pointer"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                />
              )}
            </div>
          </div>
          <div className="form-control">
            <div className="flex justify-between items-center">
              <label className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
                Tech stack
              </label>
            </div>

            <AutoComplete
              className="input input-bordered w-full rounded-[5px] h-10"
              field="name"
              multiple
              value={selectedTechListData}
              suggestions={filteredTechListData}
              completeMethod={search}
              onChange={(e) => {
                setSelectedTechListData(e.value);
                setValue((prev) => ({
                  ...prev,
                  techlist: e.value,
                }));
              }}
            />
          </div>
          <div className="form-control">
            <div className="flex justify-between items-center">
              <label className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
                Teams
              </label>
            </div>

            <AutoComplete
              className="input input-bordered w-full rounded-[5px] h-10"
              field="name"
              multiple
              value={selectedTeamListData}
              suggestions={filteredTeamListData}
              completeMethod={searchTeams}
              onChange={(e) => {
                setSelectedTeamListData(e.value);
                setValue((prev) => ({
                  ...prev,
                  teams: e.value,
                }));
              }}
            />
          </div>
          <div className="border border-gray-400 bg-white mt-6 w-full rounded-[5px] h-10 flex justify-between px-3 items-center">
            <label className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
              {value.active ? "Active" : "Inactive"}
            </label>

            <Space direction="vertical">
              <Switch
                checkedChildren="Yes"
                unCheckedChildren="No"
                defaultChecked={value.active}
                onChange={handleSwitchToggle}
              />
            </Space>
          </div>
          <input
            className="flex w-1/4 ml-auto mt-10 justify-center rounded-[5px] bg-[#161B22] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[#2a5784]"
            type="submit"
            value="Edit Member"
          />
        </form>
      </Dialog>
    </div>
  );
};

export default TeamMemberEditModal;
